import { render, staticRenderFns } from "./CodebookTable.vue?vue&type=template&id=4997bbef&"
import script from "./CodebookTable.vue?vue&type=script&lang=ts&"
export * from "./CodebookTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports